import { TenancyInventoryDTO, TenancyInventoryRespondentDTOResponseEnum } from '@reposit/api-client';
import moment from 'moment';
import React from 'react';
import { Col, Container, Row } from 'react-grid-system';
import styled from 'styled-components';
import InlineTable from '../InlineTable';
import RepositCard from '../Reposit/RepositCard';

interface InventoryDetailsProps {
  inventory: TenancyInventoryDTO;
}

const InventoryDetailsCard = styled(RepositCard)`
  width: 100%;
`;

const InventoryDetails: React.FC<InventoryDetailsProps> = ({ inventory }) => {
  const respondentThatConfirmed = (inventory.respondents || [])
    .filter((respondent) => respondent.response === TenancyInventoryRespondentDTOResponseEnum.CONFIRMED)
    .sort((a, b) => new Date(a.respondedAt).getTime() - new Date(b.respondedAt).getTime())[0];

  const items: Array<{ key: string; value: string; linkTo?: string }> = [
    {
      key: 'Confirmed',
      value: inventory.confirmed ? 'Yes' : 'No',
    },
  ];

  if (respondentThatConfirmed) {
    const { firstName, lastName, id: confirmedByUserId } = respondentThatConfirmed.user;
    items.push(
      {
        key: 'Confirmed By',
        value: `${firstName} ${lastName}`,
        linkTo: `/users/${confirmedByUserId}`,
      },
      {
        key: 'Timestamp',
        value: moment(respondentThatConfirmed.respondedAt).format('DD/MM/YYYY HH:mm:ss'),
      },
    );
  }

  return (
    <InventoryDetailsCard flush title="Inventory Details" tooltip="lorem">
      <Container>
        <Row>
          <Col lg={12} style={{ padding: 0 }}>
            <InlineTable items={items} />
          </Col>
        </Row>
      </Container>
    </InventoryDetailsCard>
  );
};

export default InventoryDetails;
